import { subscribeSyncNotifications } from './offline';

// A burst may contain membership, release and playbook events for one save.
// Keep REST authoritative and never allow a delayed refresh after revocation.
export function subscribeTeamUpdates(workspaceId: string | null, refresh: () => void, revoke: () => void): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let revoked = false;
  const unsubscribe = subscribeSyncNotifications((event) => {
    if (event.type === 'workspace_revoked' && event.workspace_id === workspaceId) {
      revoked = true;
      clearTimeout(timer);
      revoke();
      return;
    }
    if (revoked || (event.type !== 'reconnected' && !(event.type === 'sync' && event.workspace_id === workspaceId))) return;
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  });
  return () => { unsubscribe(); clearTimeout(timer); };
}
